export var DocsImageRefType;
(function (DocsImageRefType) {
    DocsImageRefType["resource"] = "Resource";
    DocsImageRefType["figmaNode"] = "FigmaNode";
})(DocsImageRefType || (DocsImageRefType = {}));
export function docsImageRefToUrl(image, sdk, from) {
    var _a;
    if (!image) {
        return undefined;
    }
    switch (image.type) {
        case DocsImageRefType.resource:
            return (_a = image.resource) === null || _a === void 0 ? void 0 : _a.url;
        case DocsImageRefType.figmaNode: {
            if (!image.figmaNode ||
                !image.figmaNode.sourceId ||
                !image.figmaNode.frameReferenceId) {
                return undefined;
            }
            return sdk.resources.getFigmaFrameHostedUrl({
                designSystemId: from.dsId,
                versionId: from.versionId,
            }, image.figmaNode.frameReferenceId);
        }
        default:
            return undefined;
    }
}
